<template>
    <new-modal size="6xl" title="Invite student" ref="inviteStudentsModal">
        <template #trigger>
            <div class="btn btn-outline">
                <div class="flex items-center gap-2">
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M2.6875 3.78125C2.6875 2.96074 3.01345 2.17383 3.59364 1.59364C4.17383 1.01345 4.96074 0.6875 5.78125 0.6875C6.60176 0.6875 7.38867 1.01345 7.96886 1.59364C8.54905 2.17383 8.875 2.96074 8.875 3.78125C8.875 4.60176 8.54905 5.38867 7.96886 5.96886C7.38867 6.54905 6.60176 6.875 5.78125 6.875C4.96074 6.875 4.17383 6.54905 3.59364 5.96886C3.01345 5.38867 2.6875 4.60176 2.6875 3.78125ZM0.4375 13.3438C0.4375 11.9265 1.0005 10.5673 2.00265 9.56515C3.0048 8.563 4.364 8 5.78125 8C7.1985 8 8.5577 8.563 9.55985 9.56515C10.562 10.5673 11.125 11.9265 11.125 13.3438V13.346L11.1243 13.4352C11.1227 13.5306 11.0968 13.624 11.0492 13.7067C11.0016 13.7894 10.9337 13.8585 10.852 13.9078C9.3214 14.8295 7.56795 15.3152 5.78125 15.3125C3.92725 15.3125 2.19175 14.7995 0.71125 13.9078C0.629388 13.8586 0.561375 13.7895 0.513615 13.7068C0.465855 13.6242 0.439919 13.5307 0.43825 13.4352L0.4375 13.3438ZM12.8125 4.625C12.8125 4.47582 12.7532 4.33274 12.6477 4.22725C12.5423 4.12176 12.3992 4.0625 12.25 4.0625C12.1008 4.0625 11.9577 4.12176 11.8523 4.22725C11.7468 4.33274 11.6875 4.47582 11.6875 4.625V6.3125H10C9.85082 6.3125 9.70774 6.37176 9.60225 6.47725C9.49676 6.58274 9.4375 6.72582 9.4375 6.875C9.4375 7.02418 9.49676 7.16726 9.60225 7.27275C9.70774 7.37824 9.85082 7.4375 10 7.4375H11.6875V9.125C11.6875 9.27418 11.7468 9.41726 11.8523 9.52275C11.9577 9.62824 12.1008 9.6875 12.25 9.6875C12.3992 9.6875 12.5423 9.62824 12.6477 9.52275C12.7532 9.41726 12.8125 9.27418 12.8125 9.125V7.4375H14.5C14.6492 7.4375 14.7923 7.37824 14.8977 7.27275C15.0032 7.16726 15.0625 7.02418 15.0625 6.875C15.0625 6.72582 15.0032 6.58274 14.8977 6.47725C14.7923 6.37176 14.6492 6.3125 14.5 6.3125H12.8125V4.625Z"
                            fill="#616161"
                        />
                    </svg>
                    <span>
                        Invite <span class="hidden md:inline">Students</span>
                    </span>
                </div>
            </div>
        </template>
        <template #content>
            <GroupInviteNewStudentForm v-on:cancel="closeModal" v-on:level-change="levelChange" :level="level" />
        </template>
    </new-modal>
</template>
<script>
import NewModal from "@/Components/NewModal";
import GroupInviteNewStudentForm from "@/Components/GroupInviteNewStudentForm";

export default {
    name: "GroupDashboardInviteStudentsModal",
    components: { NewModal, GroupInviteNewStudentForm },
    emits: ["levelChange"],
    props: {
        level: {
            type: Number,
            default: null,
        }
    },
    methods: {
        closeModal() {
            this.$refs.inviteStudentsModal.closeModal();
        },
        levelChange(val) {
            this.$emit('levelChange', val);
        },
    },
};
</script>
